// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-BlockChart----index-module---root---20yZ6","insight":"src-components-BlockChart----index-module---insight---3zWPT","title":"src-components-BlockChart----index-module---title---3jwUF","select":"src-components-BlockChart----index-module---select---1M4cn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BlockChart/index.module.css
// module id = 595
// module chunks = 168707334958949